export const environment = {
  production: false,
  microservices: {
    marketplace: "https://api-marketplace-dev.encargomio.com/api/v1/marketplace/",
    marketplace_new: "https://kbdw3zges4.execute-api.us-east-1.amazonaws.com/dev/marketplace/api/v1/",
    orders_new: "https://kbdw3zges4.execute-api.us-east-1.amazonaws.com/dev/orders/api/v1/",
    user: "https://api-user-dev.encargomio.com/api/v1/user/",
    management: "https://api-management-dev.encargomio.com/api/v1/management/",
    orders: "https://api-orders-dev.encargomio.com/api/v1/orders/",
    locker: "https://api-locker-management-dev.encargomio.com/",
    scraping:
      "https://dev.api-fn.encargomio.com/web-scrapping-page-old",
    updateConveyor:
      "https://dev.api-fn-core.encargomio.com/update-status-conveyor",
    lambdaServientrega:
      "https://dev.api-fn.encargomio.com/create-servientrega-guide",
    lambdaCourierBox:
      "https://dev.api-fn.encargomio.com/create-guide-courierbox",
    lambdaFaster:
      "https://dev.api-fn-ts.encargomio.com/nuvix-create-guide",
    lambdaFasterCity:
      "https://dev.api-fn-ts.encargomio.com/nuvix-get-city",
    lambdaFasterLabel:
      "https://dev.api-fn-ts.encargomio.com/nuvix-create-labels",
    lambdaServientregaNew:
      "https://dev.api-fn-ts.encargomio.com/servientrega-generate-awb-data",
    lambdaServientregaLabel:
      "https://dev.api-fn-ts.encargomio.com/servientrega-print-awb",
    lambdaServientregaCredentials: {
      url: "http://40.121.157.134/solucionservientrega.com/ws/wsCargaGuias.asmx",
    },
    lambdaServientregaNational:
      "https://dev.api-fn.encargomio.com/create-servientrega-nac-guide",
    lambdaServientregaNationalCredentials: {
      url: "http://190.131.194.159:8059/GeneracionGuias.asmx",
    },
    lambdaMasiveGuides:
      "https://dev.api-fn.encargomio.com/generate-masive-guides",
    lambdaLumaCreateGuide:
      "https://dev.api-fn-ts.encargomio.com/luma-send-guide",
    lambdaFenixCargoCreateGuide:
      "https://dev.api-fn-ts.encargomio.com/fenix-cargo-create-guide",
    lambdaFenixCargoGetZipcode:
      "https://dev.api-fn-ts.encargomio.com/fenix-cargo-get-zipcode",
    lambdaFenixCargoGetDepartments:
      "https://dev.api-fn-ts.encargomio.com/fenix-cargo-get-departments",
    lambdaFenixCargoGetCities:
      "https://dev.api-fn-ts.encargomio.com/fenix-cargo-get-cities",
    emod: "https://dev.encargomio.com/",
    payments: "https://api-payments-dev.encargomio.com/api/v1/payments/",
    casillero: "https://dev.casillero.encargomio.com",
  },
  scraping: {
    nike: "https://gtvlog20r6.execute-api.us-east-1.amazonaws.com/dev/web-scraping-nike",
  },
  firebase: {
    apiKey: "AIzaSyAijFdANf7CwmeJPVuivw69bsrwSjQAYk8",
    authDomain: "encargomio-ffa52.firebaseapp.com",
    projectId: "encargomio-ffa52",
    storageBucket: "encargomio-ffa52.appspot.com",
    messagingSenderId: "257092213866",
    appId: "1:257092213866:web:dd9af48b99943bdf0cbe13",
    vapidKey:
      "BEZzVfb2YyvXhgOVt-cQ_neVGLfPy4qydQfTs0-RSkBjXnr-syKGq_NzKPHljn06jX046LvEXNFsFq5Ckgr6kNI",
  },
};
